import React, { useEffect, useRef, useState } from 'react';
import { addDoc, collection, doc, getDoc, serverTimestamp, setDoc, updateDoc } from 'firebase/firestore';
import EmojiPicker from 'emoji-picker-react';
import { db } from '../../services/firebaseConfig';
import hugeicons_sent from "../../images/hugeicons_sent.png";

export const SendMessage = ({ conversationId, recipientId, profile, recipientExists }) => {
  const [input, setInput] = useState('');
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [error, setError] = useState('');
  const emojiPickerRef = useRef(null);
  const username = localStorage.getItem('username');

  const onEmojiClick = (emojiObject) => {
    if (emojiObject) {
      setInput((prev) => prev + emojiObject.emoji);
    }
  };

  const sendMessage = async (e) => {
    e.preventDefault();
    setError('');

    if (!input.trim()) return;

    if (!recipientExists) {
      setError('User has been deleted. You cannot send messages.');
      return;
    }

    const messageData = {
      message: input,
      senderId: username,
      timestamp: serverTimestamp(),
      status: 'sent',
    };

    setInput('');

    try {
      // Ensure current user exists
      const userRef = doc(db, 'users', username);
      const userDoc = await getDoc(userRef);
      if (!userDoc.exists()) {
        await setDoc(userRef, {
          username,
          name: localStorage.getItem('user_name'),
          profilePic: localStorage.getItem('profilePic'),
          lastSeen: serverTimestamp(),
        });
      } else {
        await updateDoc(userRef, { lastSeen: serverTimestamp() });
      }

      // Check if recipient still exists (again for double safety)
      const recipientRef = doc(db, 'users', recipientId);
      const recipientDoc = await getDoc(recipientRef);
      if (!recipientDoc.exists()) {
        setError("The recipient has been deleted.");
        return;
      }

      // Add message
      await addDoc(collection(db, 'conversations', conversationId, 'messages'), messageData);

      // Update or set conversation metadata
      const conversationRef = doc(db, 'conversations', conversationId);
      const conversationDoc = await getDoc(conversationRef);
      const lastMessagePayload = {
        message: input,
        status: "sent",
        senderId: username,
        timestamp: serverTimestamp(),
      };

      if (conversationDoc.exists()) {
        await updateDoc(conversationRef, {
          lastMessage: lastMessagePayload,
        });
      } else {
        await setDoc(conversationRef, {
          participants: [username, recipientId],
          lastMessage: lastMessagePayload,
        });
      }
    } catch (err) {
      console.error("Error sending message:", err);
      setError("Something went wrong while sending the message.");
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (emojiPickerRef.current && !emojiPickerRef.current.contains(event.target)) {
        setShowEmojiPicker(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div style={{ position: 'relative' }}>
      <form onSubmit={sendMessage} style={{ display: 'flex', alignItems: 'center' }}>
        <button
          type="button"
          className='send-button'
          onClick={() => setShowEmojiPicker((prev) => !prev)}
          style={{ marginRight: '10px', cursor: 'pointer' }}
          disabled={!recipientExists}
        >
          😊
        </button>

        <input
          className="form-control form-control-lg"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder={recipientExists ? "Type a message" : "User no longer exists"}
          style={{ flex: 1 }}
          disabled={!recipientExists}
        />

        <button type="submit" className='send-button' disabled={!recipientExists || !input.trim()}>
          <img src={hugeicons_sent} alt="send" />
        </button>
      </form>

      {showEmojiPicker && (
        <div
          ref={emojiPickerRef}
          style={{
            position: 'absolute',
            bottom: '50px',
            left: '10px',
            zIndex: 1000,
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          }}
        >
          <EmojiPicker onEmojiClick={onEmojiClick} />
        </div>
      )}

      {error && (
        <div style={{ color: 'red', marginTop: '5px', fontSize: '14px' }}>{error}</div>
      )}
    </div>
  );
};
